/*
 * layout view for the response area
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesAddModal/modalViewContainer/template/modalContainer.html",
], function (Marionette, Messenger, ModalTemplate) {
  var ModalContainer = {};

  ModalContainer.modalLayout = Marionette.Layout.extend({
    template: ModalTemplate,
    regions: {
      categoryContainer: "#categoryContainer",
    },
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    onRender: function () {
      var _this = this;
      const waitTimeInMilliSeconds = 700;
      this.$el.i18n();
      this.$el.find("input").on(
        "keyup",
        delay(function () {
          _this.trigger("click:category:search", { searchText: this.value });
        }, waitTimeInMilliSeconds),
      );
      function delay(callback, ms) {
        var timer = 0;
        return function () {
          var context = this,
            args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            callback.apply(context, args);
          }, ms || 0);
        };
      }
    },
  });

  return ModalContainer;
});
